// extracted by mini-css-extract-plugin
module.exports = {"Span":"PlayerNameTag_Span__3xIaL","Form":"PlayerNameTag_Form__1JQFO","Input":"PlayerNameTag_Input__r3Tdh","CharLimit":"PlayerNameTag_CharLimit__24985"};